import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { TeamDetailFragment } from 'generated/resources/graphql'

import EditModal from 'modules/teams/components/EditModal'

import Leaders from './Leaders'
import Members from './Members'

interface Props {
  team: TeamDetailFragment
  readonly: boolean
  canSeeJobCatalog: boolean
  canSeeJobCatalogTree: boolean
  canSeeJobTitle: boolean
  hasLegacyJobCatalog: boolean
  hasDevJobCatalogTree: boolean
  canCreateJob: boolean
}

const Detail = ({
  team,
  readonly,
  canSeeJobCatalog,
  canSeeJobCatalogTree,
  canSeeJobTitle,
  hasLegacyJobCatalog,
  hasDevJobCatalogTree,
  canCreateJob,
}: Props) => {
  const [openEditModal, setOpenEditModal] = useState(false)

  return (
    <>
      <Leaders
        team={team}
        readonly={readonly}
        canSeeJobCatalog={canSeeJobCatalog}
        canSeeJobCatalogTree={canSeeJobCatalogTree}
        canSeeJobTitle={canSeeJobTitle}
        hasLegacyJobCatalog={hasLegacyJobCatalog}
      />
      <Members
        team={team}
        readonly={readonly}
        canSeeJobCatalog={canSeeJobCatalog}
        canSeeJobCatalogTree={canSeeJobCatalogTree}
        canSeeJobTitle={canSeeJobTitle}
        hasLegacyJobCatalog={hasLegacyJobCatalog}
        hasDevJobCatalogTree={hasDevJobCatalogTree}
        canCreateJob={canCreateJob}
      />
      <Box alignItems="center">
        {openEditModal && <EditModal onClose={() => setOpenEditModal(false)} team={team} />}
      </Box>
    </>
  )
}

export default Detail
